import * as React from "react";
import { useState } from "react";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import TabPanel from "@mui/joy/TabPanel";
import Dropdown from "./Dropdown";

interface TabItem {
  id: number;
  type: string;
  description: string;
}

interface TabData {
  parentId: number;
  icon: string;
  tabName: string;
  name: TabItem[];
  text: string;
}

interface TabsProps {
  data: TabData[];
}

export default function NewTabs({ data }: TabsProps) {
  const [activeTab, setActiveTab] = useState<number>(data?.[0]?.parentId ?? 1);

  return (
    <Tabs
      aria-label="tabs"
      value={activeTab}
      onChange={(_, value) => setActiveTab(value as number)}
      sx={{
        bgcolor: "transparent",
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <TabList
        className="tab-list"
        disableUnderline
        sx={{
          width: "90vw",
          display: "flex",
          justifiyContent: "center",
          alignItems: "center",
          p: 0.5,
          gap: 0.5,
          borderRadius: "xl",
          bgcolor: "transparent",
          [`& .${tabClasses.root}[aria-selected="true"]`]: {
            boxShadow: "sm",
            bgcolor: "rgb(198, 166, 108)",
          },
          "@media (max-width: 768px)": {
            flexDirection: "column",
            minWidth: "200px",

            [`& .${tabClasses.root}`]: {
              width: "100%",
              justifyContent: "flex-start",
            },
          },
        }}
      >
        {data.map((item) => (
          <Tab
            sx={{
              border: "1px solid rgba(0, 0, 0, 0.12)",
            }}
            key={item.parentId}
            disableIndicator
            value={item.parentId}
            className={`tab-name ${
              activeTab === item.parentId ? "active-tab" : ""
            }`}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              className="tab-wrapper"
            >
              <img
                src={item.icon}
                alt=""
                className="tab-icon"
                style={{
                  width: "24px",
                  height: "24px",
                  display: "none",
                }}
              />
              <h2
                style={{
                  margin: 0,
                  fontSize: "clamp(1rem, 0.857rem + 0.381vw, 1.2rem)",
                  textAlign: "center",
                  padding: "0.5rem 0",
                  lineHeight: "1.5"
                }}
              >
                {item.tabName}
              </h2>
            </div>
          </Tab>
        ))}
      </TabList>

      <div className="tab-content">
        {data.map((tabData) => (
          <TabPanel key={tabData.parentId} value={tabData.parentId}>
            <p>{tabData.text}</p>
            {tabData.name.map((item, index) => (
              <Dropdown
                key={index}
                type={item.type}
                description={item.description}
              />
            ))}
          </TabPanel>
        ))}
      </div>
    </Tabs>
  );
}
